<div style="text-align: center;">
   <h3 style="color:red;">Invalid Authorization.</h3>
</div>